import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import LocationWithUserRating from 'app/features/Store/components/LocationWithUserRating'

interface NameWithLocationProps {
  name?: string
  location?: string
  isLoading?: boolean
  rating?: number
  taxNumber?: string
}

const NameWithLocation = ({
  name,
  location,
  isLoading,
  rating,
  taxNumber
}: NameWithLocationProps) => {
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '100%',
        ...Platform.select({ native: { flex: 1 } })
      }}
    >
      <Skeleton
        loading={isLoading}
        sx={{
          backgroundColor: 'border.main',
          width: { xs: '80%', md: '45%' },
          height: 50
        }}
      >
        <Text
          variant="h5"
          lineClamp={2}
          sx={{
            fontWeight: { md: 400 },
            fontFamily: 'Nunito',
            fontSize: { md: 30 },
            lineHeight: {
              ...Platform.select({
                web: { md: '35px' },
                native: { md: 35 }
              })
            }
          }}
        >
          {name}
        </Text>
      </Skeleton>

      <LocationWithUserRating
        location={location}
        isLoading={isLoading}
        rating={rating}
        isBusinessUser
        sx={{
          width: '100%',
          display: 'flex',
          ...Platform.select({ ios: { pr: { xs: 2, sm: 0 } } })
        }}
      />

      {!!taxNumber && (
        <Text variant="subtitle2" color="text.secondary">
          <FormattedMessage
            defaultMessage="VAT ID: {taxNumber}"
            values={{ taxNumber }}
          />
        </Text>
      )}
    </Stack>
  )
}

export default NameWithLocation
